const Uif = () => {
   return (
      <>
         {/* <div className="row mb-title">
            <div className="col s12 m12 l12 x12">
               <h5><b>UNIDAD DE INFORMACIÓN FINANCIERA</b></h5>
            </div>
         </div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución UIF 28/2018</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <Link to="http://servicios.infoleg.gob.ar/infolegInternet/anexos/305000-309999/308385/norma.htm" target="_blank" class="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </Link>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución UIF 11/2011</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <Link to="http://servicios.infoleg.gob.ar/infolegInternet/anexos/175000-179999/177979/norma.htm" target="_blank" class="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </Link>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución UIF 52/2012</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <Link to="http://servicios.infoleg.gob.ar/infolegInternet/anexos/195000-199999/195785/norma.htm" target="_blank" class="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </Link>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div> */}
         <div className="section white py-5 animated fadeIn">
            {/* TÍTULO DE LA SECCIÓN */}
            <div className="row center mb-4">
               <h4 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600' }}>
                  UNIDAD DE INFORMACIÓN FINANCIERA
               </h4>
            </div>
            {/* TARJETA CONTENEDORA */}
            <div className="row justify-content-center">
               <div className="col s12 m12 l12">
                  <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '30px' }}>
                     
                     {/* ÍTEM 1: Resolución UIF 28/2018 */}
                     <div className="row valign-wrapper" style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #e0e0e0' }}>
                        <div className="col s8 m9 l10">
                           <h6 className="grey-text text-darken-3" style={{ fontWeight: '600', margin: '0', fontSize: '1.1rem' }}>
                              Resolución UIF 28/2018
                           </h6>
                        </div>
                        <div className="col s4 m3 l2 center-align">
                           <a 
                              href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/305000-309999/308385/norma.htm" 
                              target="_blank" 
                              rel="noopener noreferrer" 
                              className="btn waves-effect waves-light light-blue accent-3 z-depth-0" 
                              style={{ borderRadius: '4px', textTransform: 'none', width: '100%' }}
                           >
                              Ver
                              <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '5px' }}>visibility</i>
                           </a>
                        </div>
                     </div>
                     {/* ÍTEM 2: Resolución UIF 11/2011 */}
                     <div className="row valign-wrapper" style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #e0e0e0' }}>
                        <div className="col s8 m9 l10">
                           <h6 className="grey-text text-darken-3" style={{ fontWeight: '600', margin: '0', fontSize: '1.1rem' }}>
                              Resolución UIF 11/2011
                           </h6>
                        </div>
                        <div className="col s4 m3 l2 center-align">
                           <a 
                              href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/175000-179999/177979/norma.htm" 
                              target="_blank" 
                              rel="noopener noreferrer" 
                              className="btn waves-effect waves-light light-blue accent-3 z-depth-0" 
                              style={{ borderRadius: '4px', textTransform: 'none', width: '100%' }}
                           >
                              Ver
                              <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '5px' }}>visibility</i>
                           </a>
                        </div>
                     </div>
                     {/* ÍTEM 3: Resolución UIF 52/2012 */}
                     <div className="row valign-wrapper" style={{ display: 'flex', alignItems: 'center', marginBottom: '0', paddingBottom: '0' }}>
                        <div className="col s8 m9 l10">
                           <h6 className="grey-text text-darken-3" style={{ fontWeight: '600', margin: '0', fontSize: '1.1rem' }}>
                              Resolución UIF 52/2012
                           </h6>
                        </div>
                        <div className="col s4 m3 l2 center-align">
                           <a 
                              href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/195000-199999/195785/norma.htm" 
                              target="_blank" 
                              rel="noopener noreferrer" 
                              className="btn waves-effect waves-light light-blue accent-3 z-depth-0" 
                              style={{ borderRadius: '4px', textTransform: 'none', width: '100%' }}
                           >
                              Ver
                              <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '5px' }}>visibility</i>
                           </a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Uif